import React, { createContext, useState } from 'react';
import { Sidebar, Header, RootContainer, Logout } from 'components';
import './master-page.css';
import { useIdleTimer } from 'react-idle-timer';

export const MasterPageContext = createContext();
export function MasterPageProvider({ children }) {

    const [target, setTarget] = useState();
    const [refreshTaskSideBasedStatus, setRefreshTaskSideBasedStatus] = useState();
    const [isUserIdle, setIsUserIdle] = useState(false);

    const callbackFromSiderAction = (value) => {
        setTarget(value);
    }

    //ON IDLE CALLBACK
    const handleOnIdle = () => {
        setIsUserIdle(true);
        return getRemainingTime + getLastActiveTime;
    }

    //INIT IDLE TIMER
    const { getRemainingTime, getLastActiveTime } = useIdleTimer({
        timeout: process.env.REACT_APP_IDLE_SESSION,
        onIdle: handleOnIdle,
        debounce: 500
    });


    return (
        <MasterPageContext.Provider value={{ target, refreshTaskSideBasedStatus, setRefreshTaskSideBasedStatus }}>
            <RootContainer>
                <Sidebar callbackDispatch={(value) => callbackFromSiderAction(value)} />
                <div className="w-100">
                    <Header />
                    <div id="content">
                        {children}
                    </div>
                    {isUserIdle && <div className='position-absolute shadow-sm p-2 card d-block' style={{ top: "50%", right: "50%" }}><Logout /></div>}
                </div>
            </RootContainer>
        </MasterPageContext.Provider>
    );
}